import {
	EnvironmentProviders,
	ErrorHandler,
	Provider,
	importProvidersFrom,
	inject,
	provideEnvironmentInitializer,
} from '@angular/core';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { NotificationService } from '../services/notification/notification.service';
import { provideEnvironmentNgxMask } from 'ngx-mask';
import { environment } from 'environments/environment';
import { API_BASE_URL } from '../services/api.service';
import { ApplicationinsightsAngularpluginErrorService } from '@microsoft/applicationinsights-angularplugin-js';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import {
	DateAdapter,
	MAT_DATE_FORMATS,
	MAT_DATE_LOCALE,
} from '@angular/material/core';
import {
	LuxonDateAdapter,
	MAT_LUXON_DATE_ADAPTER_OPTIONS,
} from '@angular/material-luxon-adapter';
import { MARKED_OPTIONS, provideMarkdown } from 'ngx-markdown';
import { provideLottieOptions } from 'ngx-lottie';
import player from 'lottie-web';
import { GALLERY_CONFIG, GalleryConfig } from 'ng-gallery';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
// import { MonacoEditorModule } from 'ngx-monaco-editor-v2';

export const DT_FORMAT = {
	parse: {
		dateInput: [
			'DD',
			'DDD',
			'LLddyyyy',
			'LLddyy',
			'L/d/yy',
			'LL/dd/yyyy',
			'LL/dd/yy',
			'LL-dd-yyyy',
			'LL-dd-yy',
		],
	},
	display: {
		dateInput: 'DDD',
		monthYearLabel: 'LLL yyyy',
		dateA11yLabel: 'DD',
		monthYearA11yLabel: 'LLLL yyyy',
	},
};

export const provideClaimMosaic = (): Array<
	Provider | EnvironmentProviders
> => {
	// Base providers
	const providers: Array<Provider | EnvironmentProviders> = [
		{
			provide: API_BASE_URL,
			useValue: environment.apiUrl,
		},

		{
			provide: ErrorHandler,
			useClass: ApplicationinsightsAngularpluginErrorService,
		},

		importProvidersFrom(MatSnackBarModule),
		provideEnvironmentInitializer(() => inject(NotificationService)),

		{
			provide: DateAdapter,
			useClass: LuxonDateAdapter,
			deps: [MAT_DATE_LOCALE, MAT_LUXON_DATE_ADAPTER_OPTIONS],
		},
		{ provide: MAT_DATE_FORMATS, useValue: DT_FORMAT },

		provideCharts(withDefaultRegisterables()),

		provideEnvironmentNgxMask(),
		provideMarkdown(),
		{
			provide: MARKED_OPTIONS,
			useValue: {
				gfm: true,
				breaks: false,
				renderer: {
					link(data: any) {
						const { href, text } = data;
						return `<a href="${href}"  class="markdown-link">${text}</a>`;
					},
				},
			},
		},
		provideLottieOptions({
			player: () => player,
		}),
		{
			provide: GALLERY_CONFIG,
			useValue: {
				imageSize: 'contain',
				thumbnails: true,
				bullets: true,
			} as GalleryConfig,
		},

		// importProvidersFrom(MonacoEditorModule.forRoot()),

		importProvidersFrom(InfiniteScrollModule),
	];

	// Return the providers
	return providers;
};
